import { Align, Button, ButtonLink, Justify, Row, Size } from '@busybusy/webapp-react-ui';
import { AppStoreBadge, GooglePlayBadge } from 'assets/icons';
import classNames from 'classnames';
import { IconButton } from 'components';
import OnboardingSuccessPage from 'containers/onboarding/OnboardingSuccessPage/OnboardingSuccessPage';
import useBrandTitle from 'hooks/meta/useBrandTitle';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import './OwnerOnboardingSuccessPage.scss';

export interface IOwnerOnboardingSuccessPageProps {
  firstName: string;
  onExploreAppClick: () => void;
  scheduleDemoHref: string;
  className?: ClassName;
}

function OwnerOnboardingSuccessPage({
  onExploreAppClick,
  firstName,
  scheduleDemoHref,
  className,
}: IOwnerOnboardingSuccessPageProps) {
  const brand = useBrandTitle();
  const classes = classNames('owner-onboarding-success-page', className);

  return (
    <OnboardingSuccessPage className={classes} memberName={firstName}>
      <div className={'next-container'}>
        <h2 className="mb-5 next-title">{t("What's next?")}</h2>
        <div className={'desktop-explore'}>
          <span>{t("You're now ready to start adding employees and projects to your account. We also offer")} </span>
          <span>{t('one-on-one assistance to help you get started and answer any questions.')}</span>
          <Button type="primary" className="mt-5" onClick={onExploreAppClick}>
            {t('Explore the App')}
          </Button>
        </div>
        <div className={'mobile-explore'}>
          <span>
            {t(
              'To continue using {{brand}} on your phone, we recommend you download the app. To use the website, we recommend you log on from your computer.',
              { brand }
            )}
          </span>
          <Row align={Align.CENTER} justify={Justify.CENTER} className={'my-6'}>
            <div>
              <IconButton
                svg={AppStoreBadge}
                size={Size.GROW}
                onClick={() => window.open('https://apps.apple.com/us/app/busybusy-gps-time-clock-mobile/id990495923')}
              />
            </div>
            <div>
              <IconButton
                svg={GooglePlayBadge}
                size={Size.GROW}
                onClick={() => window.open('https://play.google.com/store/apps/details?id=com.busyllc.busybusy')}
              />
            </div>
          </Row>

          <span>
            {t('We also offer one-on-one assistance to help you get started and answer any questions you may have.')}
          </span>
        </div>

        <ButtonLink type="secondary" href={scheduleDemoHref} className="schedule-demo-button mt-5" newTab={true}>
          {t('Schedule Walkthrough')}
        </ButtonLink>
      </div>
    </OnboardingSuccessPage>
  );
}

export default OwnerOnboardingSuccessPage;
